import React from 'react'
import styled from 'styled-components'

const MyselfGrid = () => {

  const myConetnts = [
    {
      name: "Design",
      description: "Transforming concepts into captivating visual experiences, My design services fuse creativity and functionality, I craft designs that leave a lasting impression on the digital landscape"
    },
    {
      name: "Development",
      description: "I specialize in crafting efficient, and scalable solutions that bring your ideas to life. From seamless website functionality to innovative web applications, we're dedicated to turning your vision into a dynamic and interactive reality"
    },
    {
      name: "Full Stack",
      description: "Empowering your digital journey from end to end, my full-stack services cover every aspect of web development , Elevate your online presence with my holistic approach to full-stack development"
    },

  ]
  return (
    <MyselfGridDiv>
      <div className="myselfGridDiv">

        <MySelfTitle className="mySelfTitle">
          <h3> Collaboratively shaping excellence for... </h3>
        </MySelfTitle>

        <div className="mySelfContent">

          {myConetnts.map((item, index) => (
            <MyContent className="myContent" key={index}>
              <div className="ContentNumber">
                <span>
                  {index + 1}
                </span>
                <div className="line" />
              </div>
              <div className="contentTitle">
                <h3> {item.name} </h3>
              </div>

              <div className="contentDesc">
                <p> {item.description}</p>
              </div>
            </MyContent>
          ))}

        </div>
      </div>
    </MyselfGridDiv>
  )
}

export default MyselfGrid

const MyContent = styled.div`
  display: flex;
  width: 30%;
  gap: 2rem;
  flex-direction: column;

  @media only screen and (max-width: 720px) {
    width: 100% !important;
  }

  .ContentNumber{
    display: flex;
    flex-direction: column;
    span{
      font-family: var(--font1);
      font-size: 1rem;
      padding-left: 0.5rem;
      padding-bottom: 1.5rem;

      @media only screen and (max-width: 720px) {
        display: none;
      }
    }
  }

  .contentTitle{
    h3{
      font-size: 2rem;
      font-family: var(--font7);
      letter-spacing: 1px;
      font-weight: 600;

      @media only screen and (max-width: 835px) {
        font-size: 1.75rem !important;
      }
    }
  }

  .contentDesc{

    p{
      font-size: 1rem;
      font-weight: 400;
      letter-spacing: 1px;
      font-family: var(--font7);

      @media only screen and (max-width: 835px) {
        font-size: .8rem !important;
      }
    }
  }
`

const MySelfTitle = styled.div`
  display: flex;
  padding-top: 7rem;

  h3{
    font-family: var(--font2);
    font-size: 4em;

    @media only screen and (max-width: 835px) {
      font-size: 3rem !important;
    }
  }
`

const MyselfGridDiv = styled.div`
  min-height: 70vh;
  margin-bottom: 30vh;
  
  
  @media only screen and (max-width: 720px) {
    margin-bottom: 20vh !important;
  }

  .myselfGridDiv{
    display: flex;
    flex-direction: column;
    row-gap: 10rem;

    .mySelfContent{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      @media only screen and (max-width: 720px) {
        flex-direction: column;
        gap: 3rem;
        padding: 0 1rem;
      }
    }
  }
`